export default __webpack_public_path__ + "static/media/fa-icon-28-pink.9e145390.svg";